export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;

export function convertMsToSeconds(ts: number): number {
    return ts / 1000;
}
